import FormInputTypes from '../../components/atoms/formEnums/formInputTypes';
import { IconType } from '../../components/atoms/icon/icon';
import { IconCustomType } from '../../components/atoms/iconCustom/iconCustom';
import routes from '../../routes/route';
import formGraphicManagerLiveManifestContent from './formGraphicManagerLiveManifestContent';
// import formSportRoomConfigContentMassUpdate from './formSportRoomConfigContentMassUpdate';
export default {
  attributeName: 'graphicManagerManifestContent',
  isDragable: false,
  canOpen: true,
  canEdit: false,
  canCreate: false,
  canRemove: true,
  isMultiSelectable:false,
  newButton:true,
  editURL:'graphicmanagers/resource',
  getURL:'graphicmanagers/resources',
  updateURL:'graphicmanagers/resource',
  removeURL:'graphicmanagers/resource',
  deleteRecordText:"You are about to delete the graphic resource and it´s historic views. Are you totally sure?",
  popupContentFormNew:[formGraphicManagerLiveManifestContent],
  popupContentFormEdit:[formGraphicManagerLiveManifestContent],
  // popupContentFormSecondary:[formSportRoomConfigContentMassUpdate],
  sessionParams: [],

  emptyMessage: "You don't have any graphic manifest on this manager, click on the \"+\" icon to create one.",
  fields: [
    // {
    //   attributeName: 'id',
    //   label: 'Id',
    //   type: FormInputTypes.TEXT,
    //   default: '',
    //   canOrder: false,
    //   canEdit: true,
    //   canCreate: true,
    //   canFilter: false,
    //   helpText: 'Content id.',
    // },
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: true,
      canCreate: true,
      canFilter: true,
      helpText: 'Name of the manifest.',
    },
    {
      attributeName: 'tags',
      label: 'Tags',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: true,
      canCreate: true,
      canFilter: true,
      helpText: 'Name of config.',
    },
    {
      attributeName: 'type',
      label: 'Type',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      helpText: 'Name of config.',
      exactWidth:'100px'
    },
    {
      attributeName: 'inEpoch',
      label: 'In',
      type: FormInputTypes.TIMESTAMPMS,
      default: '',
      canOrder: false,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      helpText: 'In time.',
      exactWidth:'100px'

    },
    {
      attributeName: 'outEpoch',
      label: 'Out',
      type: FormInputTypes.TIMESTAMPMS,
      default: '',
      canOrder: false,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      helpText: 'Out time.',
      exactWidth:'100px'

    },
    {
      attributeName: 'times',
      label: 'Times',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      helpText: 'Times included into the live.',
      exactWidth:'100px'
    },
    {
      attributeName: 'isLive',
      label: 'Is Live',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      hidden:true,
      canOrder: false,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      helpText: 'Times included into the live.',
    },
    {
      attributeName: 'in',
      type: FormInputTypes.LINK,
      postUrl:'graphicmanagers/resource/in',
      swalTitle:'In graphic',
      swalText:'Are you sure you want to incude the graphic in live?',
      iconWhen:{"field":"isLive","value":"FIXED","customIcon":IconCustomType.FIXED,"enabled":false,"else":({"field":"isLive","value":"LIVE","customIcon":IconCustomType.LIVE,"enabled":false,"else":{"customIcon":IconCustomType.IN,"enabled":true}})},
      width: '8rem',
      target:'_self',
      iconSize:'2x',
      iconColor:'#6CC24A',
      exactWidth:'100px'

    },
    {
      attributeName: 'out',
      type: FormInputTypes.LINK,
      postUrl:'graphicmanagers/resource/out',
      swalTitle:'Out graphic',
      swalText:'Are you sure you want to drop the graphic from live?',
      iconWhen:{"field":"isLive","value":"FIXED","customIcon":IconCustomType.OUT,"enabled":true,"else":({"field":"isLive","value":"LIVE","customIcon":IconCustomType.OUT,"enabled":true,"else":{"customIcon":IconCustomType.OUTDISABLED,"enabled":false}})},
      icon: IconType.OUT,
      width: '8rem',
      target:'_self',
      iconSize:'2x',
      iconColor:'#c82333',
      exactWidth:'100px'

    },   
    {
      attributeName: 'url',
      type: FormInputTypes.LINKFRAME,
      label:"Preview",
      postUrl:'graphicmanagers/resource/out',
      swalTitle:'Preview Image',
      swalText:'Are you sure you want to drop the graphic from live?',
      icon: IconType.VIEW,
      width: '4rem',
      target:'_self',
      iconSize:'2x',
      iconColor:'#000000',
    },   
  ],
};
